import { ColorReference, Keyword } from '../../values/index.js';
import { fixReference as fixColorReference } from '../basic/color.js';
import { Set } from '../../index.js';
export var LinkDecorationStyle;
(function (LinkDecorationStyle) {
    LinkDecorationStyle["underline"] = "underline";
    LinkDecorationStyle["dotted"] = "dotted";
    LinkDecorationStyle["double"] = "double";
    LinkDecorationStyle["none"] = "none";
})(LinkDecorationStyle = LinkDecorationStyle || (LinkDecorationStyle = {}));
export const Props = (props = {}) => ({
    textColor: ColorReference(props.textColor),
    linkDecoration: Keyword(props.linkDecoration, LinkDecorationStyle)
});
export const fix = (props, styles) => ({
    ...props,
    textColor: fixColorReference(props.textColor, styles)
});
export const validate = () => true;
export const type = 'palette';
export const label = 'Text color';
export const property = 'paletteIds';
export const category = 'aspect';
export const forms = [
    {
        label: 'Text color',
        id: 'palette',
        extractProperties: Props,
        validate: () => true
    }
];
export const summarize = (props, styles, formId) => {
    const color = Set.findByTypeAndId(styles || [], 'color', props.textColor.id);
    switch (formId) {
        case 'palette':
            return color ? `rgba(${color.props.red}, ${color.props.green}, ${color.props.blue}, ${color.props.alpha})` : 'None';
        default:
            return color ? `${color.details.title}` : props.textColor.id;
    }
};
//# sourceMappingURL=palette.js.map